const pendingRemovalTimers = {};

export default pendingRemovalTimers;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/pendingRemovalTimers.js